<header [ngClass]="getTheme()" [class.center-title]="centerTitle">
  <div class="title">
    {{ title }}
  </div>
  <div class="buttons-wrapper">
    <button *ngIf="showCloseButton" class="close-btn" (click)="onCloseModalClicked($event)">
      <i class="icofont icofont-close"></i>
    </button>
  </div>
</header>
